module.exports = __webpack_public_path__ + "static/media/green_tick.17116f84.svg";